<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>充值</el-breadcrumb-item>
      <el-breadcrumb-item>发币订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
    <el-row @keyup.enter.native="loadData(1)">
      <el-input v-model="queryField.send_id" size="small" placeholder="发币人id"></el-input>
<!--      <el-input v-if="show" v-model="queryField.send_name" size="small" placeholder="发币人帐号"></el-input>-->
      <el-input v-model="queryField.receive_id" size="small" placeholder="收币人id"></el-input>
      <el-input v-model="queryField.game_name" size="small" placeholder="游戏名称"></el-input>
<!--      <el-input v-if="show" v-model="queryField.receive_name" size="small" placeholder="收币人帐号"></el-input>-->
      <el-select v-model="queryField.change_type">
        <el-option value="" label="变动类型"></el-option>
        <el-option value="1" label="给下级发币"></el-option>
        <el-option value="2" label="给玩家发币"></el-option>
        <el-option value="3" label="自助充值"></el-option>
        <el-option value="4" label="给玩家发绑币"></el-option>
      </el-select>
      <el-autocomplete
            v-if="isSupper"
            class="inline-input"
            v-model="first"
            :fetch-suggestions="querySearch"
            value-key="nickName"
            placeholder="一级渠道"
            @select="handleSelect"
      ></el-autocomplete>
      <el-select v-model="queryField.is_free">
        <el-option value="" label="是否赠送"></el-option>
        <el-option value="0" label="否"></el-option>
        <el-option value="1" label="赠送"></el-option>
      </el-select>
      <el-input v-model="queryField.remark" size="small" placeholder="备注"></el-input>
      <el-date-picker
              v-model="queryField.time"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
      </el-date-picker>

      <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
      <el-button type="primary" size="small" @click="reset">重置</el-button>
      <el-button size="small" type="success" style="height: 32px;"  @click="exportExcel" :loading="loading" loading-text="下载中">导出</el-button>
    </el-row>

    <div v-if="isShowAmount" style="display: flex;width: 100%;">
        <p class="grid-name">总金额:{{ allAmount }}</p>
    </div>
        
    <el-table class="cps-table-data"
            :data="tableData" size="small"
            border
            :height="height"
            style="width: 100%">
      <el-table-column
          prop="order_id"
          label="订单id"
          width="100">
      </el-table-column>
      <el-table-column
              prop="send_id"
              label="发币人id"
              width="100">
      </el-table-column>
      <el-table-column
              prop="send_name"
              label="发币人帐号"
              width="100">
      </el-table-column>
      <el-table-column
          prop="receive_id"
          label="收币人id"
          width="100">
      </el-table-column>
      <el-table-column
          prop="receive_name"
          label="收币人帐号"
          width="120">
      </el-table-column>
      <el-table-column
          prop="game_id"
          label="游戏id"
          width="60">
      </el-table-column>
      <el-table-column
          prop="game_name"
          label="游戏名称"
          width="100">
      </el-table-column>
      <el-table-column
              prop="change_type"
              label="变动类型"
              :formatter="formatChangeType"
              width="120">
      </el-table-column>
      <el-table-column
          prop="is_free"
          label="赠送"
          width="50">
        <template slot-scope="scope">
          <p>{{ scope.row.is_free === 0 ? '否' : '赠送' }}</p>
        </template>
      </el-table-column>
      <el-table-column
          prop="order_money"
          label="订单金额"
          width="120">
      </el-table-column>
      <el-table-column
          prop="pay_money"
          label="支付金额"
          width="80">
      </el-table-column>
      <el-table-column
          prop="receive_money"
          label="实收金额"
          width="80">
      </el-table-column>
      <el-table-column
          prop="pay_nick_name"
          label="支付昵称"
          width="120">
      </el-table-column>
      <el-table-column
          prop="remark"
          label="备注"
          width="160">
      </el-table-column>
      <el-table-column
          prop="order_status"
          label="订单状态"
          :formatter="formatOrderStatus"
          width="120">
      </el-table-column>
      <el-table-column
              prop="add_time"
              label="充值时间"
              width="160">
      </el-table-column>
    </el-table>
    <el-pagination  class="fixed-pagination"
            @current-change="loadData"
            background
            :page-size="15"
            :current-page="currentIndex"
            layout="total, prev, pager, next"
            :total="total">
    </el-pagination>
    </div>
  </div>
</template>
<script>
import {adminOrderList, freeChannelDropDown, exportCoinOrder, queryAllAmount} from '@/api/request'

  export default {
    name: 'coinLogList',
    data() {
      return {
        queryField: {
          send_id: '',
          // send_name: '',
          receive_id: '',
          // receive_name: '',
          time: [],
          change_type: '',
          start_time: '',
          end_time: '',
          game_name: '',
          is_free: '',
          remark: '',
          channel_first: ''
        },
        tableData: [],
        total: 0,
        loading: false,
        currentIndex:1,
        height: window.innerHeight - 210,
        isShowAmount: false,
        allAmount: '',
        isSupper: true,
        first: '',
        restaurants:[],
      };
    },
    mounted() {
      this.loadData(1);
      this.loadAll();
    },
    methods: {
      loadData(index) {
        if (this.queryField.time != null && this.queryField.time.length > 0) {
          this.queryField.start_time = this.queryField.time[0] + " 00:00:00";
          this.queryField.end_time = this.queryField.time[1] + " 23:59:59";
        }
        else {
          this.queryField.start_time = "";
          this.queryField.end_time = "";
        }
        let params = {
          pageNo: index,
          pageSize: 15,
          params : this.queryField,
        }
        adminOrderList(params).then(res => {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.currentIndex=index;
        });
        if((this.queryField.is_free != '' && this.queryField.is_free != '0') || this.queryField.remark != ''){
          this.loadAllAmount();
        }else {
          this.isShowAmount = false;
        }
      },
      loadAllAmount(){
        queryAllAmount(this.queryField).then(res => {
          this.allAmount = res.data.data.allAmount;
          this.isShowAmount = true;
        });
      },
      exportExcel(){
        if(this.queryField.start_time){
          this.queryField.start_time += ' 00:00:00';
        }else {
          this.queryField.start_time = '';
        }

        if(this.queryField.end_time){
          this.queryField.end_time += ' 23:59:59';
        }else{
          this.queryField.end_time = '';
        }
        this.loading = true;
        exportCoinOrder(this.queryField).then( res => {
          this.downloadTabulation(res.data)
        })
      },
      downloadTabulation(data){
        if(!data){
          return
        }
        let url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.ms-excel"}));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download',"发币订单导出.xls");
        document.body.appendChild(link);
        link.click();
        //释放临时对象url
        window.URL.revokeObjectURL(url);
        this.loading=false;
      },
      querySearch(queryString, cb) {
        let restaurants = this.restaurants
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
        // 调用 callback 返回建议列表的数据
        cb(results)
      },
      handleSelect(item) {
        this.queryField.channel_first = item.value
        console.log(item.value);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.nickName.indexOf(queryString.toLowerCase()) === 0)
        }
      },
      loadAll() {
        let me = this
        freeChannelDropDown().then(res => {
          me.restaurants1 = []
          let item1 = {}
          item1.value = ''
          item1.nickName = '全部'
          me.restaurants.push(item1)
          res.data.data.forEach(function (e) {
            if (!e.send_name) {
              e.send_name = e.send_id
            }
            let item = {}
            item.value = e.send_id
            item.nickName = e.send_name
            me.restaurants.push(item)
          })
        })
      },
      reset(){
        this.queryField = {
          send_id: '',
          receive_id: '',
          time: [],
          change_type: '',
          start_time: '',
          end_time: '',
          game_name: '',
          is_free: '',
          remark: '',
          channel_first: ''
        }
        this.first = '';
      },
      formatChangeType(row, column, cellValue) {
        let ret = ''
        if (cellValue===1) {
          ret = "给下级发币"
        } else if (cellValue===2){
          ret = "给玩家发币"
        } else if (cellValue===3) {
          ret = "自助充值"
        } else if (cellValue===4) {
          ret = "给玩家发绑币"
        } 
        return ret;
      },
      formatOrderStatus(row, column, cellValue) {
        let ret = ''
        if (cellValue===1) {
          ret = "待支付"
        } else if (cellValue===2){
          ret = "已支付"
        } else if (cellValue===3) {
          ret = "超时"
        }
        return ret;
      }
    },
  }
</script>
<style lang="scss" scoped>
  /deep/ .is-active {
    background-color: unset !important;
  }
</style>
